<template>
  <div
    class="list-item__wrapper"
    style="
      display: flex;
      width: 100%;
      border-radius: 8px;
      width: 95%;
      margin: 1rem auto;
      border: 0 !important;
      -webkit-box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
      box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
      padding: 0 1.5rem;
      margin-left: auto;
      background: var(--base-ui-colour);
    "
  >
    <div class="list-item__content" style="display: flex">
      <div style="display: flex; flex-direction: column; margin: auto 0">
        <div
          class="list-item__content-detail project-name"
          style="display: flex; flex-direction: row; font-weight: 700"
        >
          <div v-if="!renamingAnalysis" style="margin-right: 1rem">
            {{ thisAnalysisNameRenamed }}
          </div>

          <div v-if="renamingAnalysis == true" @click.stop.prevent="">
            <input
              name="slide-name"
              type="text"
              style="width: 40rem"
              v-model="thisAnalysisNameRenamed"
              @change="saveAnalysisTitle"
            />
            <button
              @click="renamingAnalysis = !renamingAnalysis"
              style="background-color: transparent; border: none"
            >
              <SvgIconMeaningful icon="check" title="save title" />
            </button>
          </div>

          <span class="project-status" v-if="projectStatus" style="margin-left: 0.5rem">
            ({{ translate(projectStatus, $options.name) }})
          </span>

          <div v-if="project.benchmarkAnalysis && project.benchmarkAnalysis > 0">
            <img
              style="width: 1.25rem; opacity: 0.75; margin: 0 0.5rem"
              src="/assets/benchmarking_chart.png"
              alt="has benchmarking analysis"
              title="has benchmarking analysis"
            />
          </div>
          <div v-if="project.textAnalysisObjects && project.textAnalysisObjects > 0">
            <img
              style="width: 1.35rem; opacity: 0.75; margin: 0 0.5rem"
              src="/assets/sentiment_chart.png"
              alt="has text analysis"
              title="has text analysis"
            />
          </div>
          <div v-if="project.performanceAnalysis && project.performanceAnalysis > 0">
            <img
              style="width: 1.25rem; opacity: 0.75; margin: 0 0.5rem"
              src="/assets/performance_chart.png"
              alt="has bar charts"
              title="has bar charts"
            />
          </div>
          <div v-if="project.outliersAnalysis && project.outliersAnalysis > 0">
            <img
              style="width: 1.25rem; opacity: 0.75; margin: 0 0.5rem"
              src="/assets/outliers_analysis.png"
              alt="has outliers analysis"
              title="has outliers analysis"
            />
          </div>
          <div v-if="project.driversAnalysis && project.driversAnalysis > 0">
            <img
              style="width: 1.25rem; opacity: 0.75; margin: 0 0.5rem"
              src="/assets/matrix_chart.png"
              alt="has drivers/regression analysis"
              title="has drivers/regression analysis"
            />
          </div>
        </div>

        <span
          class="list-item__content-detail last-modified-date"
          style="color: var(--base-colour-light)"
        >
          <VisibleText>Last Modified </VisibleText>
          {{ formatDate(project.last_modified_on.$date, setLanguage) }}
        </span>
      </div>

      <!-- <ProjectsItemProgress :project="project" v-if="datasetNotDeleted" />
      <ProjectsItemDatasetDeleted v-else /> -->
      <ProjectsItemDatasetDeleted v-if="!datasetNotDeleted" />
    </div>
    <ProjectsItemNav
      :project="project"
      :setToEdit="setToEdit"
      :setToReport="setToReport"
      :setToShare="setToShare"
    />
  </div>
</template>

<script>
import moment from 'moment';

// Components
import ProjectsItemDatasetDeleted from './ProjectsItemDatasetDeleted.vue';
import ProjectsItemNav from '@/components/Projects/ProjectsItemNav.vue';
// import ProjectsItemProgress from "@/components/Projects/ProjectsItemProgress.vue"
import SvgIconMeaningful from '@/components/UI/Svg/SvgIconMeaningful.vue';

// Models
import BenchmarkingProject from '@/models/BenchmarkingProjectModel.js';

// Mixins

export default {
  name: 'ProjectsList',
  components: {
    ProjectsItemDatasetDeleted,
    ProjectsItemNav,
    SvgIconMeaningful,
  },
  props: {
    project: {
      default: () => {},
      type: BenchmarkingProject,
    },
    datasetProjects: {
      default: () => [],
      type: Array,
    },
    setToEdit: {
      default: () => false,
      type: Boolean,
    },
    setToReport: {
      default: () => false,
      type: Boolean,
    },
    setToShare: {
      default: () => false,
      type: Boolean,
    },
    setToRename: {
      default: () => false,
      type: Boolean,
    },
  },
  data() {
    return {
      renamingAnalysis: false,
      thisAnalysisNameRenamed: '',
    };
  },
  created() {
    if (this.project.name) {
      this.thisAnalysisNameRenamed = this.project.name;
    }
  },
  computed: {
    datasetNotDeleted() {
      const datasetIds = this.datasetProjects.map((dataset) => dataset.dataset_id);
      return this.project.datasets.every((dataset) => datasetIds.includes(dataset));
    },
    projectStatus() {
      const id = this.$store.getters['user/getProfile'].django_ref_id;
      const email = this.$pigeonline.getUserEmail();

      const access = this.project.access_type;
      if (access && access == 'public__all') return 'public';
      if (access && access == 'public__team') return 'team';

      const shared =
        this.project.shared &&
        Array.isArray(this.project.shared) &&
        this.project.shared.map((r) => this.bkCompatiblePk(r));
      if (shared && (shared.includes(id) || shared.includes(email))) {
        return 'shared';
      }

      return null;
    },
    setLanguage() {
      return this.$store.getters.getLanguage;
    },
  },
  methods: {
    bkCompatiblePk(r) {
      return ['string', 'number'].includes(typeof r)
        ? r
        : typeof r.pk !== 'undefined'
          ? r.pk
          : typeof r.id !== 'undefined'
            ? r.id
            : -1;
    },
    formatDate: (value, language) => {
      let currentLang = '';
      if (language) {
        currentLang = language;
      }
      if (value) {
        if (currentLang === 'fr') {
          return moment(value).locale('fr').format('MMMM D, YYYY');
        } else {
          return moment(value).format('MMMM D, YYYY');
        }
      }
    },
    async saveAnalysisTitle() {
      let response = await this.$pigeonline.projects.getByID(BenchmarkingProject, this.project.id);
      if (response) {
        response.name = this.thisAnalysisNameRenamed;
        await this.$pigeonline.projects.update(response);
      }
      this.toggleRename();
    },
    toggleRename() {
      this.renamingAnalysis = !this.renamingAnalysis;
    },
    deepCloneObj(obj) {
      // deep clones an object using JSON stringify (data loss might occur)
      if (Array.isArray(obj)) {
        return obj.map((item) => JSON.parse(JSON.stringify(item)));
      } else if (typeof obj == 'object') {
        return JSON.parse(JSON.stringify(obj));
      }
    },
  },
  watch: {
    setToRename: async function (val) {
      if (val) {
        this.toggleRename();
      }
    },
  },
};
</script>
